import React from "react";
import CardLessDataTableWithSearch from "../../datatables/CardLessDataTableWithSearch";

const comparisonColumns = (nameLabel) => [
    { dataField: "name", text: nameLabel, sort: true },
    { dataField: "students", text: "Students", sort: true },
    { dataField: "averageMarks", text: "Avg Marks", sort: true },
    { dataField: "averageAccuracy", text: "Avg Accuracy", sort: true, formatter: (cell) => `${cell}%` },
    { dataField: "highestMarks", text: "Highest", sort: true },
    { dataField: "lowestMarks", text: "Lowest", sort: true },
    { dataField: "attendancePercent", text: "Attendance %", sort: true, formatter: (cell) => `${cell}%` },
    { dataField: "passPercent", text: "Pass %", sort: true, formatter: (cell) => `${cell}%` },
];

// Shared by ClassComparison and SectionComparison — both group the same student
// rows by a different key (class_id vs section_id) into an identically-shaped
// aggregate (see buildExamAnalytics's groupBy), so one table renderer covers both.
export function ComparisonTable({ data, nameLabel, tableName }) {
    if (!data || data.length === 0) {
        return <p className="text-muted text-center py-3 mb-0">No data available</p>;
    }
    return (
        <CardLessDataTableWithSearch
            parentData={data}
            particlecolumns={comparisonColumns(nameLabel)}
            defaultSorted={[{ dataField: "averageMarks", order: "desc" }]}
            name={tableName}
            placeholder={`Search ${nameLabel.toLowerCase()}...`}
        />
    );
}

function ClassComparison({ data }) {
    return <ComparisonTable data={data} nameLabel="Class" tableName="class_comparison" />;
}

export default ClassComparison;
